import React from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';

import css from './ListingPage.module.css';

const Description = props => {
  const { formattedText } = props;

  return formattedText ? (
    <div className={css.sectionDamageDeposit}>
      <h2 className={css.damageDepositTitle}>
        <FormattedMessage id="ListingPage.descriptionTitle" />
      </h2>
      <p className={css.damageDeposit}>
        <FormattedMessage
          id="ListingPage.rulesDescription"
          values={{
            text: (
              <span>
                {formattedText}
              </span>
            ),
          }}
        />
      </p>
    </div>
  ) : null;
};

Description.defaultProps = {
  formattedText: null,
};

Description.propTypes = {
  formattedText: string,
};

export default Description;
